import { Spinner, SpinnerWrapper } from './CheckingBody.styles'

/**
 * 결과 본문 영역에서 API 응답 대기 중 표시 — 검색 인풋은 부모(AddressSearchModal)가 그대로 유지.
 * placeholder 텍스트보다 시각 피드백이 명확한 스피너 회전.
 */
export default function CheckingBody() {
  return (
    <SpinnerWrapper
      role='status'
      aria-label='수거 가능 지역인지 확인 중'>
      <Spinner aria-hidden='true' />
    </SpinnerWrapper>
  )
}
